import script from "./imageText.vue?vue&type=script&setup=true&lang=js"
export * from "./imageText.vue?vue&type=script&setup=true&lang=js"

import "./imageText.vue?vue&type=style&index=0&id=39a119ad&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39a119ad"]])

export default __exports__